<template lang="pug">
div.padding
    div.m-b-sm.p-t-sm
        div.w-lg.pull-right.m-b-sm
            outlet-selector

        h5.m-b-0._300 User Management

    div.clearfix

    div.box
        v-server-table(
            :url="api",
            :name="tableName",
            ref="datatable",
            :columns="columns",
            :options="options"
        )
            template(slot="outlets", slot-scope="props")
                span.label.primary.m-r-xs(v-for="o in props.row.outlets") {{ o.name }}

            template(slot="roles", slot-scope="props")
                span.label.primary.m-r-xs(v-for="r in props.row.roles") {{ r.display_name }}

</template>

<script>
import { mapGetters } from 'vuex';

export default {
    data() {
        var that = this;

        return {
            tableName: 'VUETABLE_USER',
            outlets: [],
            columns: ['name', 'email', 'outlets', 'roles'],
            options: {
                useReportFilter: true,
                permission: {
                    create: () => this.permission.SAVE_USER,
                    delete: () => this.permission.DELETE_USER,
                },
                sortable: ['name', 'email'],
                checkbox: {
                    delete_title: 'Delete User',
                    api_delete: Laroute.route('users.delete'),
                },
                create_btn: {
                    title: 'Create User',
                    action: () => {
                        this.$router.push('/create');
                    },
                },
                rowClassCallback: () => {
                    return this.canUpdate ? 'pointer' : '';
                },
                rowClickCallback: row => {
                    if (this.canUpdate) this.$router.push(`/${row.id}`);
                },
                checkboxDisableCallback: row => {
                    return row.id === this.user.id;
                },
            },
            userId: null,
        };
    },

    computed: {
        api() {
            return Laroute.route('users.list');
        },

        canUpdate() {
            return this.can(this.permission.SAVE_USER);
        },

        ...mapGetters('Auth', ['user']),
    },
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/user/user-list.vue